import { useLocale } from '../contexts/LocaleContext';
import { HardwareFirstTrialTerms } from '../components/HardwareFirstTrialToggle/HardwareFirstTrialModal';
import { formatHardwarePrice } from '../lib/hardwareFirst';
import useFreeTrialShippingPrice from './useFreeTrialShippingPrice';
import useHardwareFirstMembershipTerms from './useHardwareFirstMembershipTerms';

/**
 * The prices the hardware-first trial terms quote: the tracker's list price plus the 12-month membership's
 * first-year and renewal figures. Undefined until the list price and the membership terms have loaded.
 */
export default function useHardwareFirstTrialTerms(
  listPriceInCents: number | undefined,
): HardwareFirstTrialTerms | undefined {
  const locale = useLocale();
  const shippingPrice = useFreeTrialShippingPrice();
  const yearTerm = useHardwareFirstMembershipTerms().find((term) => term.renewalMonths === 12);

  return yearTerm && listPriceInCents !== undefined
    ? {
        listPrice: formatHardwarePrice(listPriceInCents, locale),
        firstYear: yearTerm.intro,
        renewal: yearTerm.renewal,
        shippingPrice,
      }
    : undefined;
}
